/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Badges_Unavailableforpurchase3Inputs */

const id_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia untuk dibeli`)
};

const ms_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia untuk dibeli`)
};

const da_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke tilgængelig for køb`)
};

const de_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht zum Kauf verfügbar`)
};

const en_us2_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unavailable for purchase`)
};

const es_es2_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible para comprar`)
};

const es_mx2_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible para comprar`)
};

const fil_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi mabibili`)
};

const fr_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponible à l'achat`)
};

const it_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non disponibile per l'acquisto`)
};

const hu_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem vásárolható meg`)
};

const nl_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet beschikbaar voor aankoop`)
};

const no_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke tilgjengelig for kjøp`)
};

const pl_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedostępne do zakupu`)
};

const pt_br2_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponível para compra`)
};

const pt_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponível para compra`)
};

const ro_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponibil pentru cumpărare`)
};

const fi_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei saatavilla ostettavaksi`)
};

const sv_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte tillgänglig för köp`)
};

const vi_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể mua`)
};

const tr_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın alınamaz`)
};

const cs_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Není k dispozici k nákupu`)
};

const bg_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е налично за покупка`)
};

const ru_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступно для покупки`)
};

const uk_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступно для придбання`)
};

const ar_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير متاح للشراء`)
};

const hi_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खरीद के लिए अनुपलब्ध`)
};

const th_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พร้อมจำหน่าย`)
};

const ja_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入できません`)
};

const zh_cn2_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂不可购买`)
};

const zh_hant1_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫時無法購買`)
};

const ko_offerdetail_badges_unavailableforpurchase3 = /** @type {(inputs: Offerdetail_Badges_Unavailableforpurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매할 수 없음`)
};

/**
* | output |
* | --- |
* | "Unavailable for purchase" |
*
* @param {Offerdetail_Badges_Unavailableforpurchase3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_badges_unavailableforpurchase3 = /** @type {((inputs?: Offerdetail_Badges_Unavailableforpurchase3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Badges_Unavailableforpurchase3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "ms") return ms_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "da") return da_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "de") return de_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "fil") return fil_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "fr") return fr_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "it") return it_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "hu") return hu_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "nl") return nl_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "no") return no_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "pl") return pl_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "pt") return pt_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "ro") return ro_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "fi") return fi_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "sv") return sv_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "vi") return vi_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "tr") return tr_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "cs") return cs_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "bg") return bg_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "ru") return ru_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "uk") return uk_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "ar") return ar_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "hi") return hi_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "th") return th_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "ja") return ja_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_badges_unavailableforpurchase3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_badges_unavailableforpurchase3(inputs)
	return ko_offerdetail_badges_unavailableforpurchase3(inputs)
});
export { offerdetail_badges_unavailableforpurchase3 as "offerDetail.badges.unavailableForPurchase" }